import React from "react";

import DeliveryCourierDocuments from "./DeliveryCourierDocuments";

export default function DeliveryDocuments() {
  return <DeliveryCourierDocuments />;
}
